export default __webpack_public_path__ + "static/media/Soldano.52e9a573.jpg";